import styled, { css } from 'styled-components';

import { basicSmallTextStyle } from '@dreryk/react-components';

type StyledMedicineActiveIngredientsProps = {
   readonly $valid: boolean;
};

export const StyledMedicineActiveIngredients = styled.div<StyledMedicineActiveIngredientsProps>`
   ${basicSmallTextStyle};

   ${(props) =>
      !props.$valid &&
      css`
         color: ${props.theme.disabledDark};
      `}
`;

StyledMedicineActiveIngredients.displayName = 'StyledMedicineActiveIngredients';
